import { useContext } from 'react';
import { UserSettingsContext, usePrompts } from '@eas/common-web';
import { CalendarDimensions } from '@enums';
import {
  CalendarHandle,
  CalendarSettingsType,
} from '../calendar/calendar-types';
import { SettingsForm } from './settings-form';
import { useSettingsSubmit } from './settings-hook';

export const settingsVersion = 1;
export const settingsId = 'CALENDAR_SETTINGS';

export enum CalendarLegendWidthEnum {
  COLLAPSED = 200,
  EXPANDED = 550,
  DEFAULT = 550,
}

export const getCalendarLegendWidth = (
  settings: Partial<CalendarSettingsType>
): number =>
  settings.legendCollapsed
    ? CalendarLegendWidthEnum.COLLAPSED
    : CalendarLegendWidthEnum.EXPANDED;

export const defualtSettings: Partial<CalendarSettingsType> = {
  dimension: CalendarDimensions.WEEK,
  rowHeight: 40,
  headerHeight: 75,
  legendWidth: CalendarLegendWidthEnum.EXPANDED,
  stepWidth: 50,
  startingHour: 6,
  endingHour: 16,
  colorForShiftV: '#D9D9D940',
  colorForShiftZ: '#ffffff',
  colorForShiftZP: '#e2edfd',
  colorForShiftA: '#bfe3c3',
  colorForShiftP: '#f9dddf',
  pinnedMap: false,
  groupToMultitaskCount: 15,
  legendSort: {
    mobileUnit: {
      field: 'name',
      order: 'ASC',
      type: 'FIELD',
    },
    technician: {
      field: 'lastName',
      order: 'ASC',
      type: 'FIELD',
    },
  },
  legendCollapsed: false,
};

export function useSettings({
  calendarRef,
}: {
  calendarRef: React.RefObject<CalendarHandle>;
}) {
  const { getCustomSettings } = useContext(UserSettingsContext);

  const savedSettings = getCustomSettings(
    settingsId,
    settingsVersion
  ) as CalendarSettingsType;

  usePrompts(
    [
      {
        key: 'PLANNER_SETTINGS_DIALOG',
        dialogTitle: 'Nastavenia',
        dialogShowClose: true,
        dialogShowConfirm: true,
        dialogWidth: 700,
        dialogText: '',
        formInitialValues: {
          ...defualtSettings,
          ...savedSettings,
        },
        FormFields: SettingsForm,
      },
    ],
    [savedSettings]
  );

  const { handleClick } = useSettingsSubmit({
    calendarRef,
  });

  return { handleClick };
}
